<template>
  <b-overlay :show="formShow" rounded="true" :fixed="true" no-fade>
    <b-card>
   

      <!-- Filters Section -->
      <div class="mb-3">
        <b-row class="w-100">
          <b-col cols="12" lg="4">
            <b-form-group label-class="text-left">
              <v-select 
                id="event" 
                v-model="selectedEvent" 
                :options="eventTypes" 
                :reduce="(val) => val" 
                :filterable="true" 
                placeholder="Search by event" 
                @option:selected="selectedEvents" 
                label="title" 
                :clearable="false" 
                input-id="event" 
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" lg="4">
            <b-form-group label-class="text-left">
              <b-input-group>
                <flat-pickr 
                  placeholder="Select Date Range" 
                  v-model="rangeDate" 
                  onClose="testClose" 
                  class="form-control" 
                  :config="datePickerConfig" 
                />
                <b-input-group-append>
                  <b-button @click="clearDate()" variant="warning">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          

          <b-col cols="12" lg="2">
            <b-form-group label-class="text-left">
              <b-button 
                @click="showArchiveRecords()" 
                variant="warning" 
                block
              >
                {{ archive == 'N' ? 'Include Archived' : 'Hide Archived' }}
              </b-button>
            </b-form-group>
          </b-col>

          
          <b-col cols="12" lg="2">
            <b-form-group label-class="text-left">
              <b-button 
              block
              class="ml-2" 
              variant="success" 
              @click="downloadPdf()" 
            >
              Download PDF
            </b-button>
         
            </b-form-group>
          </b-col>



         
        </b-row>
        <!-- Shortcut Buttons Row -->
        <b-row class="w-100 mt-1">
          <b-col cols="12" class="d-flex flex-row flex-wrap">
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectThisWeek">This Week</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectThisMonth">This Month</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectLastMonth">Last Month</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectNextMonth">Next Month</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectThisYear">This Year</b-button>
          </b-col>
        </b-row>
      </div>

      <!-- Main Content Row -->
      <b-row class="mt-3">
        <!-- Left Column -->
        <b-col cols="12" xl="6" lg="6" md="12" sm="12">
          <!-- Statistics Table -->
          <b-card class="mb-4">
            <b-card-header class="pb-0">
              <h6 class="mb-0">Statistics Summary</h6>
            </b-card-header>
            <b-card-body class="pt-2">
              <table class="table table-bordered table-sm statistics-table">
                <tbody>
                  <tr>
                    <th class="bg-secondary text-white">Total Company Score:</th>
                    <td class="bg-light text-right font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.totalCompanyScore : 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="bg-secondary text-white">Company Benchmark:</th>
                    <td class="bg-light text-right font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.companyBenchmark : 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="bg-secondary text-white">Mean / Average Score:</th>
                    <td class="bg-light text-right font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.meanScore : 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="bg-secondary text-white">Standard Deviation:</th>
                    <td class="bg-light text-right font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.standardDeviation : 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="bg-secondary text-white">Total Number of Reviews:</th>
                    <td class="bg-light text-right font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.totalNumberOfSurveys + '.00' : 'N/A' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-card>

          <!-- Normal Distribution Image -->
          <b-card>
            <b-card-header class="pb-0">
              <h6 class="mb-0">Normal Distribution Reference</h6>
            </b-card-header>
            <b-card-body class="pt-2">
              <div class="normal-distribution-section">
                <img src="../../../assets/images/normal-distribution.png" height="100%" width="100%" alt="Normal Distribution" />
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- Right Column -->
        <b-col cols="12" xl="6" lg="6" md="12" sm="12">
          <!-- Standard Deviation Chart -->
          <b-card>
            <b-card-header class="pb-0">
              <h6 class="mb-0">Standard Deviation Graph</h6>
            </b-card-header>
            <b-card-body class="pt-2">
              <div style="height: 250px; position: relative;">
                <canvas ref="standardDevChart" id="standardDevChart"></canvas>
              </div>
              
              <!-- Standard Deviation Data Table -->
              <div class="mt-3">
                <table class="table table-bordered table-sm deviation-data-table">
                  <thead class="thead-dark">
                    <tr>
                      <th class="text-center">Standard Deviation</th>
                      <th class="text-center">-3SD</th>
                      <th class="text-center">-2SD</th>
                      <th class="text-center">-1SD</th>
                      <th class="text-center">0</th>
                      <th class="text-center">1SD</th>
                      <th class="text-center">2SD</th>
                      <th class="text-center">3SD</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center">
                      <td class="bg-primary text-white font-weight-bold">Count</td>
                      <td>{{ resultData.standardDeviationDistribution ? resultData.standardDeviationDistribution['-3SD'] : 0 }}</td>
                      <td>{{ resultData.standardDeviationDistribution ? resultData.standardDeviationDistribution['-2SD'] : 0 }}</td>
                      <td>{{ resultData.standardDeviationDistribution ? resultData.standardDeviationDistribution['-1SD'] : 0 }}</td>
                      <td>{{ resultData.standardDeviationDistribution ? resultData.standardDeviationDistribution['0'] : 0 }}</td>
                      <td>{{ resultData.standardDeviationDistribution ? resultData.standardDeviationDistribution['1SD'] : 0 }}</td>
                      <td>{{ resultData.standardDeviationDistribution ? resultData.standardDeviationDistribution['2SD'] : 0 }}</td>
                      <td>{{ resultData.standardDeviationDistribution ? resultData.standardDeviationDistribution['3SD'] : 0 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Information Section -->
              <div class="mt-4">
                <div class="info-section">
                  <h6 class="info-header">
                    <feather-icon icon="InfoIcon" size="16" class="mr-1"></feather-icon>
                    What does this Standard Deviation Graph show?
                  </h6>
                  <div class="info-content">
                    <p class="mb-2"><strong>Purpose:</strong> This graph displays how reviewee scores are distributed relative to the company average.</p>
                    <ul class="info-list">
                      <li><strong>-3SD to -1SD:</strong> Reviewees performing significantly below average</li>
                      <li><strong>0 (Center):</strong> Reviewees performing at the company average</li>
                      <li><strong>+1SD to +3SD:</strong> Reviewees performing significantly above average</li>
                    </ul>
                    <p class="mb-0"><small class="text-muted">Each standard deviation represents approximately 68% of normal distribution within ±1SD, 95% within ±2SD, and 99.7% within ±3SD.</small></p>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <template #overlay v-if="download">
      <div class="text-center">
        <p id="cancel-label"><feather-icon icon="DownloadIcon" /> Report creating please wait...</p>
      </div>
    </template>
  </b-overlay>
</template>

<script>
import { BCol, BRow, BTab, BTabs, BCard, BAlert, BLink, VBModal, VBTooltip, BTooltip } from 'bootstrap-vue';
import { ref, onUnmounted } from '@vue/composition-api';
import ChartjsComponentBarChart from './charts-components/ChartjsComponentBarChart.vue';
import { Chart } from 'chart.js';
//   import Chart from 'chart.js/auto';


import store from '@/store';
import reportStoreModule from '../reportStoreModule';
import ImageCropper from '@core/components/image-cropper/ImageCropper.vue';
import { required, alphaNum, email } from '@validations';
import Ripple from 'vue-ripple-directive';
import vSelect from 'vue-select';
import Cleave from 'vue-cleave-component';
import 'cleave.js/dist/addons/cleave-phone.us';
import router from '@/router';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import axiosIns from '@/libs/axios';
import _ from 'lodash';
import { t } from '@/@core/libs/i18n/utils';
import { backgroundColor } from 'echarts/lib/theme/dark';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { $themeColors } from '@themeConfig';

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BRow,
    BCol,
    BTooltip,

    vSelect,
    Cleave,
    ToastificationContent,
    ImageCropper,
    ValidationProvider,
    ValidationObserver,
    flatPickr,

    ChartjsComponentBarChart,
  },

  directives: {
    Ripple,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },



  props: ['StatTrigger','selectedSites'],

  data: function() {
    return {
      archive: 'N',
      resultData: {
        surveyName: '',
        statistics: null,
        standardDeviationDistribution: null,
        normalDistribution: null,
        chartData: [],
        chartColour: '#028BCB'
      },
      rangeDate: null,
      filterDateStart: null,
      filterDateEnd: null,
      baseURL: store.state.app.baseURL,
      required,
      alphaNum,
      email,
      standardDevChart: null,
      dropdownLoading: false,
      download: false,
      formShow: false,
      schools: [],
      selectedSchool: null,
      groups: [],
      allGroupsData: [],
      filteredQuestions: [],
      selectedEvent: null,
      ans: null,
      summaryList: null,
      answerTypes: [1, 2, 3, 4, 'Not Observed'],
      eventTypes: [],
      refreshChart: false,
      // UI date range string in UK format (dd/mm/YYYY to dd/mm/YYYY). Internal filterDateStart/End remain ISO (YYYY-MM-DD)
      datePickerConfig: {
        mode: 'range',
        dateFormat: 'd/m/Y',
        locale: { firstDayOfWeek: 1 },
        onChange: (selectedDates) => {
          if (selectedDates && selectedDates.length === 2) {
            this.applySelectedDates(selectedDates[0], selectedDates[1]);
          }
        }
      }
    };
  },
  mounted() {
    // Initialize charts with a small delay to ensure DOM is ready
    this.$nextTick(() => {
      setTimeout(() => {
        this.initializeCharts();
      }, 100);
    });
  },

  created() {
    // Initialize with current month date range similar to TaskReport component
    this.setDefaultMonthRange();
  },

  watch: {
    rangeDate: {
      handler: function(val, before) {
        if (val != null) {
          if (val.includes('to')) {
            this.filterDateStart = this.rangeDate.split(' to ')[0];
            this.filterDateEnd = this.rangeDate.split(' to ')[1];

            this.selectedEvents();
          }
        }
      },
    },
    StatTrigger: {
      handler: function(val, before) {
        if (val === 'ObserverStandardDeviation') {
          this.getReviewResults();
          this.resultData = {
            surveyName: '',
            statistics: null,
            standardDeviationDistribution: null,
            normalDistribution: null,
            chartData: [],
            chartColour: '#028BCB'
          };
        }
      },
      immediate: true,
    },
    selectedSites(newVal, oldVal){
      if(newVal !== oldVal && this.selectedEvent){
        this.selectedEvents();
      }
    }
  },
  methods: {
    setDefaultMonthRange() {
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const format = d => {
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      this.filterDateStart = format(firstDay);
      this.filterDateEnd = format(lastDay);
      this.rangeDate = this.toUkRange(firstDay, lastDay);
      this.selectedEvents();
    },
    toUk(date){
      const d = String(date.getDate()).padStart(2,'0');
      const m = String(date.getMonth()+1).padStart(2,'0');
      const y = date.getFullYear();
      return `${d}/${m}/${y}`;
    },
    toUkRange(start, end){
      return `${this.toUk(start)} to ${this.toUk(end)}`;
    },
    applySelectedDates(start, end){
      const iso = d=> `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      this.filterDateStart = iso(start);
      this.filterDateEnd = iso(end);
      this.rangeDate = this.toUkRange(start,end);
      this.selectedEvents();
    },
    setRange(start, end) {
      const format = d => {
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      this.filterDateStart = format(start);
      this.filterDateEnd = format(end);
      this.rangeDate = this.toUkRange(start,end);
      this.selectedEvents();
    },
    selectThisWeek() {
      const now = new Date();
      const dayOfWeek = (now.getDay() + 6) % 7; // Monday=0
      const monday = new Date(now);
      monday.setDate(now.getDate() - dayOfWeek);
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      this.setRange(monday, sunday);
    },
    selectThisMonth() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0));
    },
    selectLastMonth() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), now.getMonth() - 1, 1), new Date(now.getFullYear(), now.getMonth(), 0));
    },
    selectNextMonth() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), now.getMonth() + 1, 1), new Date(now.getFullYear(), now.getMonth() + 2, 0));
    },
    selectThisYear() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), 0, 1), new Date(now.getFullYear(), 11, 31));
    },
    showArchiveRecords() {
      if (this.archive == 'Y') {
        this.archive = 'N';

        this.selectedEvents();
      } else {
        this.archive = 'Y';

        this.selectedEvents();
      }
    },
    initializeCharts() {
      // Initialize standard deviation chart
      let standardCtx = document.getElementById('standardDevChart');
      if (standardCtx) {
        this.standardDevChart = new Chart(standardCtx, {
          type: 'line',
          data: {
            labels: [],
            datasets: []
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: false },
            layout: {
              padding: 10
            },
            scales: {
              xAxes: [{ 
                gridLines: { display: true },
                ticks: { 
                  fontColor: '#6e6b7b',
                  fontSize: 12
                }
              }],
              yAxes: [{ 
                gridLines: { color: 'rgba(200, 200, 200, 0.2)' },
                ticks: { 
                  fontColor: '#6e6b7b',
                  fontSize: 12,
                  beginAtZero: true
                }
              }]
            }
          }
        });
      }
    },

    createStandardDeviationChart() {
      if (!this.standardDevChart || !this.resultData.standardDeviationDistribution) return;

      const labels = ['-3SD', '-2SD', '-1SD','0', '1SD', '2SD', '3SD'];
      const data = [
        this.resultData.standardDeviationDistribution['-3SD'] || 0,
        this.resultData.standardDeviationDistribution['-2SD'] || 0,
        this.resultData.standardDeviationDistribution['-1SD'] || 0,
        this.resultData.standardDeviationDistribution['0'] || 0,
        this.resultData.standardDeviationDistribution['1SD'] || 0,
        this.resultData.standardDeviationDistribution['2SD'] || 0,
        this.resultData.standardDeviationDistribution['3SD'] || 0
      ];

      this.standardDevChart.data = {
        labels: labels,
        datasets: [{
          data: data,
          borderColor: this.resultData.chartColour || '#028BCB',
          backgroundColor: 'transparent',
          borderWidth: 3,
          fill: false,
          tension: 0.1
        }]
      };
      this.standardDevChart.update();
    },

    downloadPdf() {
      this.formShow = true;
      this.download = true;
      
      // Get chart image data
      let chartImageData = null;
      
      try {
        // Capture the standard deviation chart
        if (this.$refs.standardDevChart) {
          chartImageData = this.$refs.standardDevChart.toDataURL('image/png');
        }
        

      } catch (error) {
        console.warn('Could not capture chart/image data:', error);
      }

      // Format date range for display
      let datePeriod = 'All Time';
      if (this.filterDateStart && this.filterDateEnd) {
        const startDate = new Date(this.filterDateStart);
        const endDate = new Date(this.filterDateEnd);
        datePeriod = `${startDate.toDateString()} to ${endDate.toDateString()}`;
      }

      // Prepare the data from your component
      const reportData = {
        statistics: this.resultData.statistics,
        standardDeviationDistribution: this.resultData.standardDeviationDistribution,
        surveyName: this.resultData.surveyName || this.selectedEvent?.title || 'Observer Standard Deviation Report',
        chartColour: this.resultData.chartColour,
        chartImage: chartImageData,
        datePeriod: datePeriod,
        selectedEvent: this.selectedEvent,
        archive: this.archive
      };

      // Make the API call
      axiosIns.post('reports/download-standard-deviation-pdf', reportData, {
        responseType: 'blob'
      })
      .then(response => {
        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'observer-standard-deviation-report.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            text: '📊 Observer Standard Deviation Report downloaded successfully!',
            icon: 'DownloadIcon',
            variant: 'success',
          },
        });
      })
      .catch(error => {
        console.error('PDF download error:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            text: 'Failed to generate PDF report',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      })
      .finally(() => {
        this.download = false;
        this.formShow = false;
      });
    },

    // Download Excel export (Company Benchmark / Standard Deviation)
    downloadExcel() {
      if (!this.selectedEvent || !this.selectedEvent.id || this.download) return;
      this.formShow = true;
      this.download = true;

      const payload = {
        eventId: this.selectedEvent.id,
        archive: this.archive,
        startDate: this.filterDateStart,
        endDate: this.filterDateEnd,
        school: this.selectedSchool && this.selectedSchool !== 'All School' ? this.selectedSchool : null,
      };

      store.dispatch('report/exportCompanyBenchmark', payload)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'observer-standard-deviation-report.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Excel Exported',
              text: 'Observer Standard Deviation Excel file downloaded successfully.',
              icon: 'DownloadIcon',
              variant: 'success',
            },
          });
        })
        .catch(error => {
          console.error('Excel export error:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Export Failed',
              text: 'Unable to generate Excel file. Please try again later.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          this.download = false;
          this.formShow = false;
        });
    },

    getLastEvent() {
      this.formShow = true;
      store
        .dispatch('report/getLastEventItem', [])
        .then((res) => {
          if (res.data) {
            this.selectedEvent = res.data;
            this.selectedEvents(res.data);
          }
        })
        .catch((error) => {
          console.log(error);
          this.formShow = false;
        });
    },
    clearDate() {
      if (this.rangeDate != null && this.rangeDate != '') {
        this.filterDateStart = null;
        this.filterDateEnd = null;
        this.rangeDate = null;
        this.selectedEvents();
      }
    },
    filterBySchool() {
      this.selectedEvents(undefined);
    },
    getReviewResults() {
      this.formShow = true;

      let filter = {
        event: this.selectedEvent ? this.selectedEvent : null,
        filterDate: {
          startDate: this.filterDateStart,
          endDate: this.filterDateEnd,
        },
        archive: this.archive,
        sites: this.selectedSites && this.selectedSites.length ? this.selectedSites : null,
      };

      store
        .dispatch('report/getAllReviewResults', filter)
        .then((res) => {

          if(res.data.length){
          this.summaryList = res.data[0].summary;
          this.totalRows = res.data.length;
          this.getLastEvent();
          res.data.forEach((element) => {
            this.eventTypes.push(element.event);
          });

          this.eventTypes = _.uniqBy(this.eventTypes, function(e) {
            return e.id;
          });
        }
          this.formShow = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectedEvents(event) {
      if (event != undefined) {
        this.selectedSchool = null;
      }

      let filter = {
        event: event == undefined ? this.selectedEvent : event,
        filterDate: {
          startDate: this.filterDateStart,
          endDate: this.filterDateEnd,
        },
        school: this.selectedSchool && this.selectedSchool !== 'All School' ? this.selectedSchool : null,
        archive: this.archive,
        sites: this.selectedSites && this.selectedSites.length ? this.selectedSites : null,
      };
      
      store
        .dispatch('report/getReviewStandardDeviation', filter)
        .then((res) => {
          // Handle new API response format
          if (res.data && res.data.data) {
            this.resultData = res.data.data;
            
            // Create the standard deviation chart with the new data
            this.createStandardDeviationChart();
            
            this.formShow = false;
          }
        })
        .catch((error) => {
          this.formShow = false;
          console.log(error);
        });
    },

  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.left-align .nav-tabs .nav-link {
  justify-content: left !important;
}

.statistics-table {
  width: 100%;
  margin-bottom: 2rem;
  
  th {
    background-color: #6c757d !important;
    color: white !important;
    font-weight: 600;
    border: 1px solid #545454;
    padding: 8px 12px;
  }
  
  td {
    background-color: #f8f9fa !important;
    border: 1px solid #dee2e6;
    padding: 8px 12px;
    font-weight: 600;
  }
}

.normal-distribution-section {
  h6 {
    font-weight: 600;
    color: #343a40;
  }
}

.placeholder-chart {
  height: 200px;
  background-color: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-content {
  text-align: center;
  
  p {
    font-weight: 600;
    font-size: 14px;
  }
  
  small {
    font-size: 12px;
  }
}

.info-section {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
}

.info-header {
  color: #495057;
  font-weight: 600;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.info-content {
  font-size: 14px;
  
  p {
    margin-bottom: 8px;
  }
}

.info-list {
  margin-bottom: 10px;
  padding-left: 20px;
  
  li {
    margin-bottom: 4px;
    font-size: 13px;
  }
}

.standard-deviation-section {
  h6 {
    font-weight: 600;
    margin: 0;
    border-radius: 4px;
  }
  
  canvas {
    max-height: 250px !important;
  }
}

.deviation-data-table {
  font-size: 0.9rem;
  
  thead th {
    background-color: #343a40 !important;
    color: white !important;
    font-weight: 600;
    border-color: #454d55 !important;
    padding: 6px 8px;
  }
  
  tbody td {
    vertical-align: middle;
    border-color: #dee2e6;
    padding: 6px 8px;
    text-align: center;
  }
  
  .bg-primary {
    background-color: #007bff !important;
    color: white !important;
  }
}
</style>
